import DisregardedClassifier from './DisregardedClassifier';
export default DisregardedClassifier;
